import React, { useEffect, useState } from 'react'
import { Container } from '@kogk/common'
import useGetRegions from '@src/hooks/useGetRegions'
import { Tag, useModal, IcelandMap } from '@islandsstofa/react'
import { regionKeyTitleMap } from '@src/utils/resolvers'

interface Props {
  caption: string
}

const MapOfIceland = ({ caption = '' }: Props) => {
  const regions = useGetRegions()

  const [focusedTagKey, setFocusedTagKey] = useState<string>()

  useEffect(() => {
    const domRegions = document.querySelectorAll('.region')

    const callback = (e: any) => {
      const tagKey = e.target.className.baseVal.replace('region region--', '')
      setFocusedTagKey(tagKey)
    }

    domRegions.forEach(region => {
      region.addEventListener('mouseenter', e => callback(e))
      region.addEventListener('mouseleave', () => setFocusedTagKey(undefined))
    })
    return () =>
      domRegions.forEach(region => {
        region.removeEventListener('mouseover', e => callback(e))
        region.removeEventListener('mouseleave', () =>
          setFocusedTagKey(undefined)
        )
      })
  }, [])

  const { executeModal } = useModal()

  return (
    <Container>
      <div className='map-of-iceland mt-2 mt-lg-4 col-lg-8 offset-lg-2 p-0'>
        <IcelandMap
          activeKey={focusedTagKey}
          keys={regions.map(r => r.region.key)}
          onRegionClick={(i: number) =>
            executeModal(regions, i, 'modal__green-tech-partner', 'Region')
          }
        />
        <p className='caption mt-2'>{caption}</p>
        <div className='mt-3'>
          {Object.keys(regionKeyTitleMap).map(x => (
            <button
              onClick={() =>
                executeModal(
                  regions,
                  regions.findIndex(r => r.region.key === x),
                  'modal__green-tech-partner',
                  'Region'
                )
              }
              key={x}
              onMouseOver={() => setFocusedTagKey(x)}
              onMouseLeave={() => setFocusedTagKey(undefined)}
            >
              <Tag type={x === focusedTagKey ? 'mapPressed' : 'map'}>
                {regionKeyTitleMap[x]}
              </Tag>
            </button>
          ))}
        </div>
      </div>
    </Container>
  )
}

export default MapOfIceland
